export const CONSTANTS = {
  appName: "Dreamie Planner v2",
  primaryTagline: "Plan gently. Live fully.",
  secondaryTagline: "Organize your days without pressure. An easy-to-use personal planner app with themes to help you relax and stay focused. A peaceful space to plan, reflect, and grow."
}

export const SECTIONS = {
  features: "Features",
  gallery: "Gallery",
  faq: "FAQs",
  guide: "Guide"
}

export const PLACEHOLDER_FEATURES = [
  {
    title: "Yearly / Monthly / Daily Planner",
    icon: "calendar-day&#FFBF6B",
    description: "Plan your stuff  in yearly, monthly, or daily view.",
    gridSize: 2,
  },
  {
    title: "Icons",
    icon: "star&#FF9B93",
    description: "Distinguish your plan with an icon and color.",
    gridSize: 1,
  },
  {
    title: "To-do Lists",
    icon: "circle-check&#FF9B93",
    description: "Create and manage to-do lists.",
    gridSize: 1,
  },
  {
    title: "Reminder",
    icon: "bell&#42C6BC",
    description: "Get notified of upcoming events.",
    gridSize: 1,
  },
  {
    title: "Quick Notes",
    icon: "note-sticky&#42C6BC",
    description: "Write note quickly on your events.",
    gridSize: 1,
  },
  {
    title: "Themes",
    icon: "palette&#FFBF6B",
    description: "Personalize your planner with themes.",
    gridSize: 2,
  },
];

export const PLAYSTORE_URL = "https://play.google.com/store/apps/details?id=com.sugarysoft.dreamieplanner";
export const APPSTORE_URL = "https://apps.apple.com/us/app/dreamie-planner-v2/id6757215482";
export const GUIDE_URL = "https://guide.dreamieplanner.com/";